import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'defaultDate',
})
export class DefaultDatePipe implements PipeTransform {
  private readonly timezone = `UTC+${
    (new Date().getTimezoneOffset() / 60) * -1
  }`;
  constructor(private datePipe: DatePipe) {}
  transform(
    value: Date | string | number | null | undefined,
    format: string = 'yyyy-MM-dd HH:mm:ss',
    timezone: string = this.timezone,
    locale?: string
  ): string | undefined | null {
    const val = value && value.toString().endsWith('Z') ? value : value + 'Z';
    return this.datePipe.transform(val, format, timezone, locale);
  }
}
